import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useEntityBasePath } from "../utils/entityPaths";
import { useIsEntityMerger } from "./entityMergerContext";
import { useIsEntityVp } from "./entityVpContext";
import { canAccessBrokerLifecycle } from "./permissions";
import { LifecycleName } from "./roles";
import { useRoles } from "./useRoles";

type Props = {
  lifecycle: LifecycleName;
  children: ReactNode;
};

export const RequireBrokerLifecycleRole = ({ lifecycle, children }: Props) => {
  const { id } = useParams<{ id?: string }>();
  const roles = useRoles();
  const isEntityVp = useIsEntityVp();
  const isMerger = useIsEntityMerger();
  const basePath = useEntityBasePath("broker");

  if (!canAccessBrokerLifecycle(roles, lifecycle, isEntityVp, isMerger)) {
    return <Navigate to={id ? `${basePath}/${id}` : "/brokers"} replace />;
  }

  return children;
};
